import type { EventDto, ParticipantDto } from '../../api/types';

import { isoToDatePart } from './iso';

// Количество участников (все участники в массиве participants уже добавлены)
export function countParticipants(event: EventDto): number {
  return event.participants.length;
}

// Проверка заполненности события
export function isEventFull(event: EventDto): boolean {
  return event.participants.length >= event.maxParticipants;
}

// Найти участника по telegramId
export function findUserSlot(event: EventDto, telegramId: string): ParticipantDto | null {
  if (!telegramId) return null;
  return event.participants.find((p) => p.telegramId === telegramId) ?? null;
}

// Количество приглашений со статусом pending для пользователя
export function countPendingInvites(events: EventDto[], telegramId: string): number {
  if (!telegramId) return 0;

  let count = 0;
  for (const event of events) {
    if (event.status !== 'active') continue;
    for (const participant of event.participants) {
      if (participant.telegramId === telegramId && participant.status === 'pending') {
        count += 1;
      }
    }
  }

  return count;
}

// Количество мероприятий на дату со статусом confirmed для пользователя
export function countConfirmedForDate(
  events: EventDto[],
  telegramId: string,
  dateKey: string
): number {
  if (!telegramId) return 0;

  let count = 0;
  for (const event of events) {
    if (event.status !== 'active') continue;
    if (isoToDatePart(event.startAt) !== dateKey) continue;
    for (const participant of event.participants) {
      if (participant.telegramId === telegramId && participant.status === 'confirmed') {
        count += 1;
        break; // один раз за мероприятие
      }
    }
  }

  return count;
}

// Количество приглашений на дату со статусом pending для пользователя
export function countPendingForDate(
  events: EventDto[],
  telegramId: string,
  dateKey: string
): number {
  if (!telegramId) return 0;

  let count = 0;
  for (const event of events) {
    if (event.status !== 'active') continue;
    if (isoToDatePart(event.startAt) !== dateKey) continue;
    for (const participant of event.participants) {
      if (participant.telegramId === telegramId && participant.status === 'pending') {
        count += 1;
        break;
      }
    }
  }

  return count;
}
